import { useState, useEffect, useMemo } from 'react';
import { featureCollection } from '@turf/helpers';
import {
  fetchHAReportsPolygons,
  fetchHAReportsImsmaLastSyncOnce,
  fetchImsmaHAReportsPolygons,
} from 'utils/HaReportsHelper';

export const useHAReports = (map) => {
  const [haReportsEnabled, setHaReportsEnabled] = useState(false);
  const [imsmaSwitchEnabled, setImsmaSwitchEnabled] = useState(false);
  const [azureLayerEnabled, setAzureLayerEnabled] = useState(false);
  const [haReportsPolygonsBase, setHaReportsPolygonsBase] = useState(featureCollection([]));
  const [imsmaHaReportsPolygons, setImsmaHaReportsPolygons] = useState(featureCollection([]));
  const [haReportsLoader, setHaReportsLoader] = useState(false);
  const [imsmaLastSyncedAt, setImsmaLastSyncedAt] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    fetchHAReportsImsmaLastSyncOnce().then((value) => {
      if (!cancelled) {
        setImsmaLastSyncedAt(value);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (haReportsEnabled && map) {
      const controller = new AbortController();
      fetchHAReportsPolygons(setHaReportsLoader, setHaReportsPolygonsBase, controller.signal);
      return () => controller.abort();
    }
    setHaReportsPolygonsBase(featureCollection([]));
  }, [haReportsEnabled, map]);

  useEffect(() => {
    if (imsmaSwitchEnabled && map) {
      const controller = new AbortController();
      fetchImsmaHAReportsPolygons(setImsmaHaReportsPolygons, controller.signal);
      return () => controller.abort();
    }
    setImsmaHaReportsPolygons(featureCollection([]));
  }, [imsmaSwitchEnabled, map]);

  const haReportsPolygons = useMemo(() => {
    const baseFeatures = (haReportsPolygonsBase?.features || []).map((feature) => ({
      ...feature,
      properties: {
        ...(feature?.properties || {}),
        __imsmaClickable: false,
      },
    }));
    const imsmaFeatures = (imsmaHaReportsPolygons?.features || []).map((feature) => ({
      ...feature,
      properties: {
        ...(feature?.properties || {}),
        __imsmaClickable: true,
      },
    }));
    return featureCollection([...baseFeatures, ...imsmaFeatures]);
  }, [haReportsPolygonsBase, imsmaHaReportsPolygons]);

  return {
    haReportsEnabled,
    setHaReportsEnabled,
    imsmaSwitchEnabled,
    setImsmaSwitchEnabled,
    azureLayerEnabled,
    setAzureLayerEnabled,
    haReportsPolygons,
    haReportsLoader,
    imsmaLastSyncedAt,
  };
};